import { Building, Building2, Briefcase, IdCard, Users, Globe, BadgeCheck } from 'lucide-react';
import type { DetailItemProps } from './DetailItem';
import { ProfileDetailSection } from './ProfileDetailSection';
import type { ProfileDisplayUser } from './types';

interface OrganizationSectionProps {
  user: ProfileDisplayUser | undefined;
}

export function OrganizationSection({ user }: OrganizationSectionProps) {
  const thanaTooltip =
    user?.districtName || user?.divisionName ? (
      <div className="flex flex-col gap-0.5">
        {user.districtName && <span>District: {user.districtName}</span>}
        {user.divisionName && <span>Division: {user.divisionName}</span>}
      </div>
    ) : null;

  const fields: DetailItemProps[] = [
    { label: 'Company', value: user?.companyName, icon: Building, tooltip: null },
    { label: 'Department', value: user?.departmentName, icon: Briefcase, tooltip: null },
    { label: 'Designation', value: user?.designationName, icon: IdCard, tooltip: null },
    { label: 'User Type', value: user?.userTypeName, icon: BadgeCheck, tooltip: null },
    { label: 'Reporting To', value: user?.parentUserName, icon: Users, tooltip: null },
    { label: 'Thana', value: user?.thanaName, icon: Globe, tooltip: thanaTooltip },
  ];

  return (
    <ProfileDetailSection
      title="Organization"
      icon={Building2}
      fields={fields}
      isLoading={user === undefined}
    />
  );
}
